import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Http, Response } from '@angular/http';
import { INascarViewModel } from '../models/INascarViewModel';
import { IDriver } from '../models/IDriver';
import { NascarService } from '../services/nascar.service';
import { Observable } from 'rxjs/Observable';

import { AlertService } from '../services/alert.service';
import { BaseService } from '../services/base.service';
import { IUser } from '../models/IUser';
import { IEntity } from '../models/IEntity';
import { IPermission } from '../models/IPermission';
import { IOrg } from '../models/IOrg';
import { AuthService } from '../account/auth.service';
import { IOrgUserRaceFilter } from '../models/IOrgUserRaceFilter';

let config = require('../../config').appConfig;

@Component({
  selector: 'app-nascar',
  templateUrl: './nascar.component.html',
  styleUrls: ['./nascar.component.scss']
})
export class NascarComponent implements OnInit {


  public isRequesting: boolean = false;
  public nascarRace: INascarViewModel;
  public group1Drivers: IDriver[];
  public group2Drivers: IDriver[];
  public group3Drivers: IDriver[];
  public disabled: boolean = true;
  public localTime: string;
  public serverStartDateTime: Date;
  public orgs: IOrg[];
  public selectedOrg: IOrg;
  public error: any;
  //private entity: IEntity = { id: '' };
  private filter: IOrgUserRaceFilter = {};
  private user: IUser;
  public canMakeChanges: boolean = false;
  public selectedDrivers: IDriver[];

  filterDriverGroup1(driver: IDriver) {
    return !(driver.group > 1)
  }

  //private _alertService: AlertService;
  constructor(private authService: AuthService,
    private nascarService: NascarService,
    private alertService: AlertService,
    private baseService: BaseService) {
     // this._alertService = alertService;
      this.user = this.authService.user;
      this.orgs = this.authService.orgs;
      this.selectedOrg = this.orgs[0];
      this.filter.userId = this.user.id;
      this.filter.orgId = this.selectedOrg.id;
  }

  ngOnInit() {
    this.getCurrentOrgUserRace();
    this.getCanMakeChanges();
    // this.model.drivers.sort(function(a, b){return a.startPosition - b.startPosition});
  }

  getCurrentOrgUserRace() {
    this.nascarService.getCurrentOrgUserRace(this.filter)
      .subscribe(result => {
        this.nascarRace = result;
        this.selectedDrivers = this.nascarRace.selectedDrivers;
        this.nascarRace.drivers.sort((a, b) => a.startPosition - b.startPosition);
        this.updateLocalDriverGroups();
        this.localTime = this.baseService.getLocalTimeFromUtc(this.nascarRace.startDateTime)

      });
  }

  getCanMakeChanges() {
    this.nascarService.getCanMakeChanges().subscribe(result => {
      this.canMakeChanges = result.approved;
    }
    );
  }


  updateLocalDriverGroups() {
    this.group1Drivers = this.nascarRace.drivers.filter(f => f.group == 1);
    this.group2Drivers = this.nascarRace.drivers.filter(f => f.group == 2);
    this.group3Drivers = this.nascarRace.drivers.filter(f => f.group == 3);

  }
  // ngOnChanges(changes: SimpleChanges): void {
  //   alert("Change Detected!");
  // }
  settCurrentOrg(org: IOrg) {
    this.selectedOrg = org;
    this.getCurrentOrgUserRace();
  }

  changeSelected(driver) {

    if (this.canMakeChanges) {
      //this.selectedDrivers = this.nascarRace.drivers.filter(f => f.isSelected == true);
      var newSelectedDrivers = this.selectedDrivers.filter(f => f.group != driver.group);

      newSelectedDrivers.push(driver);
      this.nascarRace.drivers.filter(f => f.group == driver.group)
        .forEach(a => a.isSelected = false);
      this.nascarRace.drivers.filter(f => f.driverId == driver.driverId)
        .forEach(b => b.isSelected = true);
      // this.selectedDrivers = this.nascarRace.drivers.filter(f => f.isSelected == true);
      this.updateLocalDriverGroups();
      this.selectedDrivers = newSelectedDrivers;
    }
    else {
      this.alertService.error("Race has already started");
    }

    this.nascarService.updateCurrentOrgUserRace(this.nascarRace).subscribe(data => {
      if (data)
        this.alertService.success("Driver Updated");

    },
      error => {
        this.error = error as any;
        this.alertService.error(this.error);
      }
    );



  }



}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/nascar/nascar.component.ts